import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Pagination from '../../../shared/components/pagination';
import CustomExpandableTable from '../../../shared/components/customExpandableTable';
import Loader from '../../../shared/components/loader'; 
import AdminSettingsService from '../../services/adminsettings.service';
import CONSTANT from '../../../shared/constants/constant';
import MasterService from '../../../masterdata/services/masterdata.service';
import Util from './../../../shared/util/util';
import XLSX from 'xlsx';
const moment = require('moment');

export default {
  name: 'DTHhtriplog',
  components: {
    Pagination,
    Loader,
    Multiselect,
    CustomExpandableTable,
    Util
  },
  data: function() {
    return {
      tableArr: [],
       tripid: '',
       cargotripid: '',
       awb: '',
       isLoading:false,
       Loader:false,
       showcreatedthconfig: false,
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      offset:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      tableColumn: ['Trip ID','Cargo Trip ID', 'Trip creation date', 'Trip start date','Assigned to : BA/SR Name','Origin branch','Destination','Vehicle number','Vehicle type','Vehicle capacity','Trip start ODO reading','Trip end ODO reading','Is DTH','Is DTH converted to Standard?','DTH converted reason','DTH created by'],
      innerTableColumn: ['Assigned Territory'],
      tableItems: [],
      hubaccessObjArray:[],
      hubids:null,
      motherhubArr:[],
      motherhubids:null,
    }
  },
  computed: {
  },
  mounted() {
  this.getDTHtriploglist();
  this.getHubAccessList();
  },
  methods: {
    async getHubAccessList() {
      try {
        let InputPayload = {};
      this.isLoading = true;
      let response = await MasterService.GetHublist(InputPayload);
      if(response.data.code===200){
        this.hubaccess = response.data.data.data;
        for (var i = 0; i < this.hubaccess.length; i++) {
          this.hubaccessObjArray.push({
            hubid: this.hubaccess[i].HubID,
            hubname: this.hubaccess[i].HubName
          })
        }
        this.motherhubArr = this.hubaccessObjArray
        }
        else {
          this.$alertify.error(response.data.message);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
      searchDTHtriplog(){
        this.currentPage = 1;
        this.offset = 0;
        this.getDTHtriploglist();
      },
      async getDTHtriploglist() {
        this.isLoading = true
        try {
          let inputPayload = {
            "offset": this.offset,
            "limit": this.pageLimit,
          }
          if (this.hubids != null) {
            inputPayload.hubid = this.hubids.hubid;
          } 
          if (this.motherhubids != null) {
            inputPayload.motherhubid = this.motherhubids.hubid;
          }     
          let result = await AdminSettingsService.getDTHtriplogList(inputPayload);
          this.isLoading = false;
            if(result.data.code == 200){
              this.totalCount = result.data.data.count;
              this.tableArr = result.data.data.rows;
            this.tableItems = result.data.data.rows.map((el)=>{
              return {
                  'id':el.id,
                  'Trip ID':el.tmstripid,
                  'Cargo Trip ID':el["cargotripmasters.cargotripid"],
                  'Trip creation date': Util.displayDateTimeFormat(el["cargotripmasters.tripcreateddate"]), 
                  'Trip start date':Util.displayDateTimeFormat(el["cargotripmasters.tripstartdate"]),
                  'Assigned to : BA/SR Name':el["cargotripmasters.username"],
                  'Origin branch':el["cargotripmasters.hubname"],
                  'Destination':el["cargotripmasters.motherhubname"],
                  'Vehicle number':el["cargotripmasters.vehiclenumber"],
                  'Vehicle type':el["cargotripmasters.vehicletype"],
                  'Vehicle capacity':el["cargotripmasters.vehiclecapacity"],
                  'Trip start ODO reading':el["cargotripmasters.openkm"],
                  'Trip end ODO reading':el["cargotripmasters.closekm"],
                  'Is DTH':el.isdth == 1 ? "Yes" :"No",
                  'Is DTH converted to Standard?':el.dthtostandard == 1 ? "Yes" :"No",
                  'DTH converted reason':el.changereason,
                  'DTH created by':el.createdby
              }
            })
            if (this.totalCount < this.pageLimit) {
              this.totalPage = 1
            } else {
              this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
            }
          }else{
            this.tableItems=[];
            this.$alert(result.data.message, "DTH Trip Log", "error");
            this.currentPage = 1;
            this.totalCount = 0;
            this.offset = 0;
          }
         
        } catch (err) {
          this.isLoading = false;
          console.log(err);
        }
      },
      async DownloadDTHLogs() {
        this.isLoading = true
        try {
          let inputPayload = {}
          if (this.hubids != null) {
            inputPayload.hubid = this.hubids.hubid;
          } 
          if (this.motherhubids != null) {
            inputPayload.motherhubid = this.motherhubids.hubid;
          }     
          let result = await AdminSettingsService.getDTHtriplogList(inputPayload);
          this.isLoading = false;
            if(result.data.code == 200){
            let tempdata= result.data.data.rows.map((el)=>{
              return {
                  // 'id':el.id,
                  'Trip ID':el.tmstripid,
                  'Cargo Trip ID':el["cargotripmasters.cargotripid"],
                  'Trip creation date': Util.displayDateTimeFormat(el["cargotripmasters.tripcreateddate"]), 
                  'Trip start date':Util.displayDateTimeFormat(el["cargotripmasters.tripstartdate"]),
                  'Assigned to : BA/SR Name':el["cargotripmasters.username"],
                  'Origin branch':el["cargotripmasters.hubname"],
                  'Destination':el["cargotripmasters.motherhubname"],
                  'Vehicle number':el["cargotripmasters.vehiclenumber"],
                  'Vehicle type':el["cargotripmasters.vehicletype"],
                  'Vehicle capacity':el["cargotripmasters.vehiclecapacity"],
                  'Trip start ODO reading':el["cargotripmasters.openkm"],
                  'Trip end ODO reading':el["cargotripmasters.closekm"],
                  'Is DTH':el.isdth == 1 ? "Yes" :"No",
                  'Is DTH converted to Standard?':el.dthtostandard == 1 ? "Yes" :"No",
                  'DTH converted reason':el.changereason,
                  'DTH created by':el.createdby
              }
            })
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb,dt+'DTHlog.xlsx');
          }else{
            // tempdata = []
          }
         
        } catch (err) {
          this.isLoading = false;
          console.log(err);
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
        this.getDTHtriploglist()
      },
      clearForm() {
        this.currentPage = 1;
        this.totalCount = 0;
        this.offset = 0;
        this.motherhubids = null;
        this.hubids = null;
        this.getDTHtriploglist();
        this.$validator.reset();
      },
      getCustomTableEvent(event) {
       
      },
     
  }
}



// WEBPACK FOOTER //
// ./src/modules/adminsettings/views/dthtriplog/dthtriplog.component.js